'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRootScope = exports.getLoginService = exports.invokeGIMLoginModal = exports.setAngularObject = exports.rootScope = exports.loginService = exports.angular = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require('ramda');

var _functional_utility = require('common-utilities/src/functional_utility');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GIMWebAngularService = {
  angular: null,
  loginService: null,
  rootScope: null,
  setAngularObject: function setAngularObject(angularObject) {
    this.angular = angularObject;
    var $rootScope = this.getRootScope();
    if ($rootScope && $rootScope.$$watchers) {
      for (var i = 0; i < $rootScope.$$watchers.length; i++) {
        if ($rootScope.$$watchers[i] && $rootScope.$$watchers[i].exp && _functional_utility2.default.isFunction($rootScope.$$watchers[i].exp) && (0, _ramda.isNil)($rootScope.$$watchers[i].exp.exp)) {
          $rootScope.$$watchers[i] = null;
        }
      }
      $rootScope.$apply();
    }
  },
  invokeGIMLoginModal: function invokeGIMLoginModal() {
    var loginServiceTemp = this.getLoginService();
    if (loginServiceTemp) {
      loginServiceTemp.glassDoorModal();
    }
  },
  getLoginService: function getLoginService() {
    if (this.angular && !this.loginService) {
      this.loginService = this.angular.element(_jquery2.default.find("[ng-app]")[0]).injector().get('loginService');
    }
    return this.loginService;
  },
  getRootScope: function getRootScope() {
    if (this.angular && !this.rootScope) {
      this.rootScope = this.angular.element(_jquery2.default.find("[ng-app]")[0]).injector().get('$rootScope');
    }
    return this.rootScope;
  }
};

exports.default = GIMWebAngularService;
var angular = GIMWebAngularService.angular,
    loginService = GIMWebAngularService.loginService,
    rootScope = GIMWebAngularService.rootScope,
    setAngularObject = GIMWebAngularService.setAngularObject,
    invokeGIMLoginModal = GIMWebAngularService.invokeGIMLoginModal,
    getLoginService = GIMWebAngularService.getLoginService,
    getRootScope = GIMWebAngularService.getRootScope;
exports.angular = angular;
exports.loginService = loginService;
exports.rootScope = rootScope;
exports.setAngularObject = setAngularObject;
exports.invokeGIMLoginModal = invokeGIMLoginModal;
exports.getLoginService = getLoginService;
exports.getRootScope = getRootScope;